// assets/variant-sync.js
(function () {
  const state = { scent: null, bundle: null, product: null };

  // Robust product JSON lookup
  const pscript =
    document.querySelector('[id^="ProductJson-"]') ||
    document.querySelector('[id^="product-json-"]') ||
    document.querySelector('script[type="application/json"][data-product]');
  if (!pscript) return;
  try { state.product = JSON.parse(pscript.textContent); } catch { return; }
  if (!state.product?.variants?.length) return;

  // Option indexes
  function findIdx(name, aliases = []) {
    const opts = state.product.options || [];
    const lc = String(name).trim().toLowerCase();
    let i = opts.findIndex(o => String(o).trim().toLowerCase() === lc);
    if (i !== -1) return i;
    for (const a of aliases) {
      const la = a.toLowerCase();
      i = opts.findIndex(o => String(o).toLowerCase().includes(la));
      if (i !== -1) return i;
    }
    return -1;
  }
  const scentIdx  = findIdx('Choose your Favorite scent', ['scent','fragrance']);
  const bundleIdx = findIdx('Choose your bundle', ['bundle','bags']);

  // DOM helpers
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const forms = () => $$('product-form form, form[action*="/cart/add"]');
  function ensureId(f){ let i=f.querySelector('input[name="id"]'); if(!i){i=document.createElement('input');i.type='hidden';i.name='id';f.appendChild(i);} return i; }

  function readSelectionsFromForm(f){
    const out = new Array(state.product.options.length).fill(null);
    state.product.options.forEach((opt, idx) => {
      // radios via legend/label
      const group = $$('.product-form__input, .product-form__input--pill, fieldset', f)
        .find(g => ((g.querySelector('legend, label')?.textContent)||'').toLowerCase().includes(String(opt).split(' ')[0].toLowerCase()));
      if (group){
        const r = group.querySelector('input[type="radio"]:checked');
        if (r) out[idx] = r.value;
      }
      if (out[idx] == null){
        const sel = $$('select', f).find(s => (s.name||'').toLowerCase().includes(String(opt).split(' ')[0].toLowerCase()));
        if (sel) out[idx] = sel.value;
      }
    });
    return out;
  }
  function buildOptionsArray(){
    // prefer main form as base
    const base = readSelectionsFromForm(forms()[0] || document);
    if (scentIdx  !== -1 && state.scent  != null) base[scentIdx]  = state.scent;
    if (bundleIdx !== -1 && state.bundle != null) base[bundleIdx] = state.bundle;
    const first = state.product.variants[0]?.options || [];
    for (let i=0;i<base.length;i++) if (base[i] == null) base[i] = first[i];
    return base;
  }
  function resolveVariant(){
    const sel = buildOptionsArray();
    return state.product.variants.find(v => v.options.every((o,i)=>String(o)===String(sel[i]))) || null;
  }
  function writeId(f, v){
    if (!f || !v) return;
    const id = ensureId(f);
    id.value = String(v.id);
    id.dispatchEvent(new Event('input',{bubbles:true}));
    id.dispatchEvent(new Event('change',{bubbles:true}));
    f.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function syncVariant(targetForm){
    const v = resolveVariant();
    if (!v) return;
    if (targetForm) writeId(targetForm, v); else forms().forEach(f=>writeId(f, v));
    document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:v}}));
  }

  // Public API
  window.__setScent = (val)=>{ state.scent = val; };
  window.__setBundle = (val)=>{ state.bundle = val; };
  window.__syncVariant = syncVariant;

  // First-try fix (capture phase)
  function captureGuard(e){
    const f = e.target.closest?.('form');
    if (f) syncVariant(f);
  }
  document.addEventListener('submit', captureGuard, true);
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest?.('button[name="add"], button[type="submit"], [data-add-to-cart], .shopify-payment-button__button');
    if (btn) captureGuard(e);
  }, true);
})();
